import './i18n';
import './App.css';
import QR from './pages/qr/Qr';
import Home from './pages/home/Home';
import Tags from './pages/tags/Tags';
import Login from './pages/auth/Login';
import Logout from './pages/auth/Logout';
import QrScanner from './pages/qr/QrScanner';
import GlobalModal from './modal/GlobalModal';
import { useTranslation } from 'react-i18next';
import Managers from './pages/managers/Managers';
import { AppContext } from './services/AppContext';
import Customers from './pages/customers/Customers';
import React, { useState, useContext } from 'react';
import { ModalProvider } from './modal/ModalContext';
import ResetPassword from './pages/auth/ResetPassword';
import CustomerDetails from './pages/customers/CustomerDetail';
import SpendClass from './pages/subscriptions/SpendClass';
import LanguageSelector from './components/LanguageSelector';
import GlobalLoading from './components/global/GlobalLoading';
import Subscriptions from './pages/subscriptions/Subscriptions';
import SubscriptionDetails from './pages/subscriptions/SubscriptionDetails';
import SubscriptionPresets from './pages/subscription-presets/SubscriptionPresets';
import { BrowserRouter as Router, Routes, Route, Navigate, NavLink } from 'react-router-dom';
import NotFound from './pages/notFound/NotFound';

const App = () => {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const { isAuthorized, user } = useContext(AppContext);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  return (
    <Router>
      <ModalProvider>
        <div className="app-container">
          <nav className="navbar">
            <div>
              {isAuthorized && (
                <div>
                  <button className="menu-toggle" onClick={toggleMenu}>☰</button>
                  <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
                    {user.role === 'Customer' || <NavLink to="/" className="nav-link" onClick={() => setMenuOpen(false)}>{t('navigation.home')}</NavLink>}
                    {user.role === 'Admin' && <NavLink to="/managers" className="nav-link" onClick={() => setMenuOpen(false)}>{t('common.managers')}</NavLink>}
                    {user.role === 'Admin' && <NavLink to="/customers" className="nav-link" onClick={() => setMenuOpen(false)}>{t('common.customers')}</NavLink>}
                    {user.role === 'Admin' && <NavLink to="/subscriptions" className="nav-link" onClick={() => setMenuOpen(false)}>{t('common.subscriptions')}</NavLink>}
                    {user.role === 'Admin' && <NavLink to="/tags" className="nav-link" onClick={() => setMenuOpen(false)}>{t('navigation.tags')}</NavLink>}
                    {user.role === 'Admin' && <NavLink to="/presets" className="nav-link" onClick={() => setMenuOpen(false)}>{t('navigation.presets')}</NavLink>}
                    {user.role !== 'Customer' && <NavLink to="/qr-scanner" className="nav-link" onClick={() => setMenuOpen(false)}>{t('navigation.scan')}</NavLink>}
                  </div>
                </div>
              )}
            </div>

            <div className="nav-actions">
              <LanguageSelector />
              {isAuthorized && <NavLink to="/logout" className="nav-link" onClick={() => setMenuOpen(false)}>{t('navigation.logout')}</NavLink>}
            </div>
          </nav>
          <main className="main">
            <Routes>
              <Route path="/" element={<ConditionalRoute element={<Home />} route="home" />} />
              <Route path="/login" element={<ConditionalRoute element={<Login />} route="login" />} />
              <Route path="/logout" element={<ConditionalRoute element={<Logout />} route="logout" />} />
              <Route path="/reset-password" element={<ConditionalRoute element={<ResetPassword />} route="reset-password" />} />
              <Route path="/qr" element={<ConditionalRoute element={<QR />} route="qr" />} />
              <Route path="/qr-scanner" element={<ConditionalRoute element={<QrScanner />} route="qr-scanner" />} />
              <Route path="/subscriptions" element={<ConditionalRoute element={<Subscriptions />} route="subscriptions" />} />
              <Route path="/subscription/:id" element={<ConditionalRoute element={<SubscriptionDetails />} route="subscription" />} />
              <Route path="/managers" element={<ConditionalRoute element={<Managers />} route="managers" />} />
              <Route path="/customers" element={<ConditionalRoute element={<Customers />} route="customers" />} />
              <Route path="/customer/:id" element={<ConditionalRoute element={<CustomerDetails />} route="customer" />} />
              <Route path="/spend-class" element={<ConditionalRoute element={<SpendClass />} route="spend-class" />} />
              <Route path="/tags" element={<ConditionalRoute element={<Tags />} route="tags" />} />
              <Route path="/presets" element={<ConditionalRoute element={<SubscriptionPresets />} route="presets" />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
        </div>
        <GlobalModal />
        <GlobalLoading />
      </ModalProvider>
    </Router>
  );
};

const ConditionalRoute = ({ element, route }) => {
  const { isAuthorized, user } = useContext(AppContext);
  const allowAnonymous = ['reset-password'];

  const routeConditions = {
    'logout': !isAuthorized,
    'login': isAuthorized,
    'reset-password': isAuthorized,
    'spend-class': user?.role !== 'Manager',
    'qr-scanner': user?.role === 'Customer',
  };

  if (routeConditions[route]) {
    return <Navigate to="/" replace />;
  }

  if (!isAuthorized && !allowAnonymous.includes(route)) {
    return <Login />;
  }

  return element;
};

export default App;
